import { useTranslation } from '@dagens/frontend-i18n';
import { StructuredAddress } from '../../../types/Logistics';
import { formatStructuredAddress } from '../../../utils/address';
import Typography from '@carrot-deprecated/typography';
import { DeliveryWindow } from 'types/Consumer';

type IFormattedDeliveryInformation = {
  deliveryAddress: StructuredAddress;
  deliveryInfo?: string;
  deliveryWindow?: DeliveryWindow;
};

const FormattedDeliveryInformation = ({
  deliveryAddress,
  deliveryWindow,
  deliveryInfo
}: IFormattedDeliveryInformation) => {
  const { t } = useTranslation();
  if (!deliveryWindow) {
    return null;
  }

  return (
    <>
      <Typography variant="paragraphBold" as="p">
        {formatStructuredAddress(deliveryAddress)} {t('common:between')}{' '}
        {deliveryWindow.start} - {deliveryWindow.end}
      </Typography>
      <Typography variant="paragraphSmall">{deliveryInfo}</Typography>
    </>
  );
};
export default FormattedDeliveryInformation;
